/* eslint-disable max-classes-per-file */
import React from "react";

import classnames from "classnames";
import isIntuit from "Intuit/isIntuit";
import PropTypes from "prop-types";

import makeBem from "Utils/makeBem";

const bem = makeBem("NavItem");

export interface NavItemProps {
  children: React.ReactNode;
  href?: string;
  className?: string;
  onClick?: (event: React.MouseEvent<HTMLAnchorElement>) => void;
  disabled?: boolean;
  eventKey?: any;
}

export class NavItem extends React.Component<NavItemProps> {
  handleNavigation = (url: string) => {
    window.location.href = url;
  };

  render() {
    const { children, href, className, onClick, disabled, ...rest } = this.props;
    const itemTypeClass = isIntuit() ? "intuit-default" : "default";
    const combinedClassName = classnames(bem(), bem(null, itemTypeClass), className, {
      [bem(null, "disabled")]: disabled,
    });

    return (
      <li role="presentation" className={combinedClassName}>
        <a href={href || "#"} role="button" onClick={this.handleClick} {...rest}>
          {children}
        </a>
      </li>
    );
  }

  handleClick = (e) => {
    const { onClick, href, disabled } = this.props;

    if (disabled) {
      e.preventDefault();
      return;
    }

    if (onClick) {
      onClick(e);
      if (!href && !e.defaultPrevented) {
        e.preventDefault();
      }
    } else if (href) {
    } else {
      e.preventDefault();
    }
  };
}

NavItem.propTypes = {
  children: PropTypes.node.isRequired,
  href: PropTypes.string,
  className: PropTypes.string,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  eventKey: PropTypes.any,
};

NavItem.defaultProps = {
  disabled: false,
};
